"use client";

import { useEffect, useState, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Autoplay, FreeMode } from "swiper/modules";
import { ChevronLeft, ChevronRight, Maximize2, Pause, Play, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import "swiper/css/a11y";
interface GalleryPhoto {
  id: number;
  src: string;
  srcset: string;
  sizes: string;
  alt: string;
  caption: string;
  route: string;
}
const transferPhotos: GalleryPhoto[] = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-09-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-09-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-09-1.jpg-wvc-sizes",
  alt: "Mann und Frau mit Rollkoffer und Hurghada Transfer Hub Willkommensschild vor dem Terminal 2 des Flughafens Hurghada",
  caption: "Empfang am Flughafen",
  route: "Hurghada Airport – Terminal 2"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-08-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-08-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-08-1.jpg-wvc-sizes",
  alt: "Vierköpfige Familie mit Gepäck und Hurghada Transfer Hub Willkommensschild vor einem Resorteingang",
  caption: "Abholung für Familien",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11-2-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11-2-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11-2-1.jpg-wvc-sizes",
  alt: "Junger Mann mit Hurghada Transfer Hub Willkommensschild im Flughafen-Abholbereich mit Fahrzeugen im Hintergrund",
  caption: "Flughafen-Abholbereich",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-24-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-24-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-24-1.jpg-wvc-sizes",
  alt: "Vierköpfige Familie mit Gepäck und Hurghada Transfer Hub Willkommensschild vor einem Flughafenterminal",
  caption: "Flughafenabholung für Familien",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-19.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-19.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-19.jpg-wvc-sizes",
  alt: "Drei Reisende mit Gepäck und Hurghada Transfer Hub Willkommensschild vor dem Terminal 1 des Internationalen Flughafens Hurghada",
  caption: "Empfang am Flughafen",
  route: "Hurghada Airport – Terminal 1"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11.jpg-wvc-sizes",
  alt: "Lächelnde dreiköpfige Familie vor einem Flughafenterminal-Eingang; der Sohn hält ein Hurghada Transfer Hub Willkommensschild und der Vater zeigt Daumen hoch",
  caption: "Abholung für Familien",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-06-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-06-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-06-1.jpg-wvc-sizes",
  alt: "Mann und Frau mit einem beladenen Gepäckwagen und Hurghada Transfer Hub Willkommensschild vor dem Terminal 1 des Internationalen Flughafens Hurghada",
  caption: "Empfang am Flughafen",
  route: "Hurghada Airport – Terminal 1"
}, {
  id: 9,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-09.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-09.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-09.jpg-wvc-sizes",
  alt: "Große Mehrgenerationenfamilie lächelnd im Freien unter einem Gartenbogen im Resort mit Hurghada Transfer Hub Willkommensschild",
  caption: "Familienankunft im Resort",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 10,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27-1.jpg-wvc-sizes",
  alt: "Lächelnder Reisender neben einem Fahrer mit Hurghada Transfer Hub Willkommensschild und großen Rollkoffern vor einem Flughafenterminal",
  caption: "Fahrer-Empfang",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 11,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27.jpg-wvc-sizes",
  alt: "Familie in einem privaten Transfer-Van, der Vater hält ein weißes Hurghada Transfer Hub Willkommensschild neben ihrem Gepäck",
  caption: "Familientransfer im Van",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 12,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-05.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-05.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-05.jpg-wvc-sizes",
  alt: "Lächelnde dreiköpfige Familie vor dem Terminal 2 des Flughafens Hurghada neben ihrem Transferfahrzeug mit einem Hurghada Transfer Hub Abholungs-Schild",
  caption: "Flughafenabholung für Familien",
  route: "Hurghada Airport – Terminal 2"
}, {
  id: 13,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21-1.jpg-wvc-sizes",
  alt: "Lächelnde vierköpfige Familie mit Gepäck vor einem privaten Transfer-Van, der Vater hält ein Hurghada Transfer Hub Willkommensschild",
  caption: "Abholung für Familien",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 14,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21.jpg-wvc-sizes",
  alt: "Lächelnde sechsköpfige Reisegruppe mit Rollkoffern vor dem Terminal 1 des Internationalen Flughafens Hurghada, ein Junge hält ein Hurghada Transfer Hub Willkommensschild",
  caption: "Familienankunft an Terminal 1",
  route: "Hurghada Airport – Terminal 1"
}, {
  id: 15,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-08-17-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-08-17-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-08-17-1.jpg-wvc-sizes",
  alt: "Reisegruppe mit Transferfahrer und Gepäck vor dem Terminal 1 des Internationalen Flughafens Hurghada mit einem Hurghada Transfer Hub Willkommensschild",
  caption: "Fahrer-Empfang",
  route: "Hurghada Airport – Terminal 1"
}, {
  id: 17,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-08-17.jpg",
  srcset: "",
  sizes: "",
  alt: "Vertreter von Hurghada Transfer Hub und eine lächelnde Reisende mit einem Willkommensschild in einer Resort-Einkaufspassage",
  caption: "Herzlicher Empfang im Resort",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 18,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-09-14.jpg",
  srcset: "",
  sizes: "",
  alt: "Lächelndes Paar an einer sonnigen Marina mit Hurghada Transfer Hub Willkommensschild vor türkisfarbenem Meer und einem Boot im Hintergrund",
  caption: "Abholung an der Marina",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 19,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-09-19.jpg",
  srcset: "",
  sizes: "",
  alt: "Zwei lächelnde Reisende vor dem Terminal 1 des Internationalen Flughafens Hurghada mit Gepäck und Hurghada Transfer Hub Willkommensschild",
  caption: "Freundliche Flughafenabholung",
  route: "Hurghada Airport – Terminal 1"
}];
export default function Confidence() {
  const [reduceMotion, setReduceMotion] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [activePhotoIndex, setActivePhotoIndex] = useState<number | null>(null);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduceMotion(mq.matches);
    const onChange = () => setReduceMotion(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  const openLightbox = (index: number) => {
    setActivePhotoIndex(index);
  };
  const closeLightbox = useCallback(() => {
    setActivePhotoIndex(null);
  }, []);
  const showNextPhoto = useCallback(() => {
    setActivePhotoIndex(prev => prev !== null ? (prev + 1) % transferPhotos.length : 0);
  }, []);
  const showPrevPhoto = useCallback(() => {
    setActivePhotoIndex(prev => prev !== null ? (prev - 1 + transferPhotos.length) % transferPhotos.length : 0);
  }, []);
  useEffect(() => {
    if (activePhotoIndex === null) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") showNextPhoto();
      if (e.key === "ArrowLeft") showPrevPhoto();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [activePhotoIndex, closeLightbox, showNextPhoto, showPrevPhoto]);
  return <section id="travel-with-confidence" data-nav="light" className="bg-secondary text-secondary-foreground py-16 md:py-24 overflow-hidden border-y border-border">
      <div className="mx-auto max-w-[1136px] px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 pb-10">
          <div className="max-w-xl">
            <span className="text-primary font-semibold text-xs tracking-wider uppercase">
              Reiseszenen aus ganz Ägypten
            </span>
            <h2 className="mt-2 text-3xl font-bold tracking-tight text-black sm:text-4xl md:text-5xl font-default">
              Mit Vertrauen reisen
            </h2>
            <p className="mt-3 text-secondary-foreground/80 text-base md:text-lg">
              Echte Abholungen und Transfers aus unserem Fahrservice.
            </p>
          </div>

          <div className="flex items-center gap-2 self-start md:self-auto">
            <Button variant="outline" size="sm" onClick={() => setIsPaused(prev => !prev)} aria-label={isPaused ? "Fotoleiste fortsetzen" : "Fotoleiste anhalten"} className="bg-card text-card-foreground border-border hover:bg-accent hover:text-accent-foreground">
              {isPaused ? <>
                  <Play className="size-3.5" />
                  <span className="text-xs">Fortsetzen</span>
                </> : <>
                  <Pause className="size-3.5" />
                  <span className="text-xs">Pause</span>
                </>}
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} onTouchStart={() => setIsPaused(true)} onTouchEnd={() => setIsPaused(false)}>
        <Swiper modules={[Autoplay, FreeMode, A11y]} loop={true} speed={4000} freeMode={true} slidesPerView="auto" spaceBetween={20} autoplay={reduceMotion || isPaused ? false : {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }} a11y={{
        prevSlideMessage: "Vorheriges Transferfoto",
        nextSlideMessage: "Nächstes Transferfoto"
      }} className="!overflow-visible select-none px-6">
          {transferPhotos.map((photo, i) => <SwiperSlide key={photo.id} data-index={i} className="!w-[300px] sm:!w-[380px] md:!w-[420px] shrink-0">
              <div role="button" tabIndex={0} aria-label={`Transferfoto vergrößern: ${photo.caption}`} onClick={() => openLightbox(i)} onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openLightbox(i);
            }
          }} className="group relative block aspect-[16/10] w-full overflow-hidden rounded-md border border-border bg-card shadow-xs transition-colors hover:border-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary cursor-pointer text-left">
                <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-102" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-90 transition-opacity group-hover:opacity-100" />

                <div className="absolute bottom-0 inset-x-0 p-4 text-white">
                  <div className="flex items-center justify-between gap-2">
                    <div>
                      <Link to={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(photo.route)} newTab onClick={e => e.stopPropagation()} className="inline-block hover:underline">
                        <p className="text-xs font-semibold tracking-wider text-primary uppercase">
                          {photo.route}
                        </p>
                      </Link>
                      <p className="text-sm font-medium text-white/95 mt-0.5 line-clamp-1">
                        {photo.caption}
                      </p>
                    </div>
                    <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-black/40 text-white backdrop-blur-xs transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                      <Maximize2 className="size-4" />
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>)}
        </Swiper>
      </div>

      {activePhotoIndex !== null && <div role="dialog" aria-modal="true" aria-label="Fotoanzeige für Transfers" className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm transition-opacity">
          <div className="absolute inset-0 cursor-pointer" onClick={closeLightbox} aria-hidden="true" />

          <div className="relative z-10 flex w-full max-w-4xl flex-col items-center">
            <div className="flex w-full items-center justify-between pb-3 text-white">
              <div>
                <span className="text-xs font-semibold uppercase tracking-wider text-primary">
                  <Link to={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(transferPhotos[activePhotoIndex].route)} newTab onClick={e => e.stopPropagation()} className="hover:underline">
                    {transferPhotos[activePhotoIndex].route}
                  </Link>
                </span>
                <p className="text-sm text-white/90">
                  {transferPhotos[activePhotoIndex].caption}
                </p>
              </div>

              <Button variant="outline" size="icon" onClick={closeLightbox} aria-label="Fotovorschau schließen" className="bg-card/20 text-white border-white/20 hover:bg-card/40 hover:text-white">
                <X className="size-5" />
              </Button>
            </div>

            <div className="relative aspect-[16/10] w-full overflow-hidden rounded-md border border-white/10 bg-black">
              <img src={transferPhotos[activePhotoIndex].src} data-wvc-srcset={transferPhotos[activePhotoIndex].srcset} data-wvc-sizes={transferPhotos[activePhotoIndex].sizes} alt={transferPhotos[activePhotoIndex].alt} className="h-full w-full object-cover" />
            </div>

            <div className="mt-4 flex w-full items-center justify-between">
              <div className="text-xs text-white/70">
                Foto {activePhotoIndex + 1} von {transferPhotos.length}
              </div>

              <div className="flex gap-2">
                <Button variant="outline" size="sm" onClick={showPrevPhoto} aria-label="Vorheriges Foto" className="bg-card/20 text-white border-white/20 hover:bg-card/40 hover:text-white">
                  <ChevronLeft className="size-4 mr-1" />
                  <span>Zurück</span>
                </Button>

                <Button variant="outline" size="sm" onClick={showNextPhoto} aria-label="Nächstes Foto" className="bg-card/20 text-white border-white/20 hover:bg-card/40 hover:text-white">
                  <span>Weiter</span>
                  <ChevronRight className="size-4 mr-1" />
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}